import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', () => {
  const swiperContainer = document.querySelector('.slideTitleSwiper');
  if (!swiperContainer) return

  const swiperWrapper = document.querySelector('.slideTitleSwiper .swiper-wrapper');
  
  let sliderCount = 0
  let prevInlineSize = 0

  const getScreenWidth = () => {
    return window.innerWidth;
  }

  const getSlides = () => {
    return document.querySelectorAll('.slideTitleSwiper__slide')
  }

  const calculateInitialWidth = () => {
    const slides = getSlides()
    let totalWidth = 0;

    slides.forEach((slide) => {
      totalWidth += slide.offsetWidth; // 各スライドの幅を合計
    });
    return totalWidth;
  }
  

  // スライドを複製して、画面幅を満たすまで追加
  const cloneSlides = () => {
    let totalWidth = calculateInitialWidth(); // 初回の幅を計算
    const slides = getSlides()
    const screenWidth = getScreenWidth()
    // スライドを複製して、画面幅を満たすまで追加
    while (sliderCount < ((screenWidth / totalWidth) + 1) * 3) {
      slides.forEach((slide) => {
        const clonedSlide = slide.cloneNode(true); // スライドを複製
        swiperWrapper.appendChild(clonedSlide); // 複製したスライドを追加
        totalWidth += slide.offsetWidth; // 合計幅を更新
        sliderCount++
      });
    }
  }

  // Swiperの初期化
  const pageTitleSwiper = new Swiper('.slideTitleSwiper', {
    slidesPerView: 'auto', // 一度に表示する枚数
    spaceBetween: 42,
    speed: 50000, // ループの時間
    allowTouchMove: false, // スワイプ無効
    autoplay: {
      delay: 0, // 途切れなくループ
      disableOnInteraction: false,
    },
    loop: true, // ループを有効にする
  });

  
  // ResizeObserverでSwiper要素の横幅の変化を監視
  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      const currentInlineSize = entry.contentBoxSize[0].inlineSize
      if(prevInlineSize < currentInlineSize ) {
        cloneSlides(); // スライドの複製処理を再実行
        pageTitleSwiper.update(); // Swiperの更新を実行
      }
      prevInlineSize = currentInlineSize
    })
  });

  // Swiper要素の監視を開始
  resizeObserver.observe(swiperContainer);

  // 初回実行
  cloneSlides();
});
